/**
 * SA-813: the width rule every resizable panel shares: the Inbox record
 * sidebar (SA-795) and a resizable drawer. Pure. A panel stores only the
 * number a person chose; anything else reads as the panel's default.
 */
export interface PanelWidthLimits {
  default: number
  min: number
  max: number
}

/** One arrow press, and with Shift (the register handle's steps). */
export const RESIZE_STEP = 8
export const RESIZE_STEP_SHIFT = 16

/** Whole pixels, inside the limits. */
export function clampWidth(width: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, Math.round(width)))
}

/** The width to draw for a stored value. Anything but a finite number (null,
 * or a hand-edited settings blob) is the default, and a width stored under
 * older limits is brought inside the current ones. */
export function storedWidth(stored: unknown, limits: PanelWidthLimits): number {
  return typeof stored === 'number' && Number.isFinite(stored) ? clampWidth(stored, limits.min, limits.max) : limits.default
}

/** SA-1034 PR 5 (spec §3.1): the one sentence on every resize handle. */
export const RESIZE_TIP = 'Drag to resize · double-click resets'
